<template>
  <div v-loading.fullscreen.lock="isLoading">
    <el-card>
      <div slot="header">
        <el-row style="line-height: 40px">
          <el-col :span="6">
            <div style="font-size: 16px; font-weight: bold">
              <el-button style="padding: 3px 0" type="text" @click="back">
                <i class="el-icon-arrow-left"></i>
                返回
              </el-button>
              <el-divider direction="vertical"></el-divider>
              <span> 統計排名-學制班 </span>
            </div>
          </el-col>
        </el-row>
      </div>

           <el-row style="margin-left: 40px; font-size: 16px; line-height: 10px">
        <el-col :span="6">
          <el-row>
            <span style="font-size: 30px; font-weight: bold; line-height: 20px">
              {{ studyClassTitle }}{{ groupByTitle }}
            </span>
          </el-row>
          <br/>
          <br/>
           <el-row>
            <span style="font-weight: bold;font-size: 20px;; line-height: 20px">{{ yearTitle }}</span>
          </el-row>
        </el-col>

        <el-col :span="16">
         <!-- <br />
          <br />
           <br />
          <br />
          <el-row>
             <el-tag v-if="mothballType" type="danger" effect="plain" style="margin-left: 20px">已封存</el-tag>
             <el-tag v-else type="info" effect="plain" style="margin-left: 20px">未封存</el-tag>
          </el-row> -->
        </el-col>

        <!-- <el-col :span="8">
          <el-col :span="12">
            <div style="border-right: 2px #8f8f8f solid;border-left: 2px #8f8f8f solid; min-height: 50px">
              <div style="margin-left: 20px">
                <el-row>
                  <span>學年度</span>
                </el-row>
                <br />
                <br />
                <el-row>
                  <span style="font-size: 20px; font-weight: bold; line-height: 20px">{{
                    year
                  }}</span>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div style=" min-height: 50px">
              <div style="margin-left: 20px">
                <el-row>
                  <span>學制班</span>
                </el-row>
                <br />
                <br />
                <el-row>
                  <span style="font-size: 20px; font-weight: bold; line-height: 20px">{{
                    syTitel
                  }}</span>
                </el-row>
              </div>
            </div>
          </el-col>
         
        </el-col> -->
      </el-row>

      <el-row style="font-size: 20px">
        <el-col :span="3" :offset="21">
          <el-button
            class="darkblue"
            style="float: right; margin-right: 10px"
            @click="getExcel"
            >排名總表匯出</el-button
          >
        </el-col>
      </el-row>
      <br />

      <orderTab
        :clickTime="tabTime"
        :year="year"
        :id="id"
        :name="yearTitle + studyClassTitle + groupByTitle"
        ref="tab"
      ></orderTab>
    </el-card>
  </div>
</template>

<script>
import API from "../../api";
// import Utils from "../../utils";
// import { InformType } from "@/utils/InformType";
import orderTab from "./component/orderTab";

export default {
  name: "orderByYear",

  components: { orderTab },
  data() {
    return {
      isLoading: false,
      tabPane: "all",
      tabTime: new Date(),
      year: this.$route.query.year,
      id: this.$route.query.id,
      studyClassTitle: "",
      yearTitle: "",
      groupByTitle: "",
    };
  },

  created() {
    this.query();
  },

  methods: {
    query() {
      console.log("讀取");
      this.isLoading = true;
      API.studyYear.showY(this.$route.query.id).then((res) => {
        this.yearTitle = this.$route.query.year;
        this.studyClassTitle = res.data.studyClass;
        this.groupByTitle = res.data.groupBy;
        (this.tabTime = new Date()), console.log(res.data);
        this.isLoading = false;
      });
    },

    back() {
      this.$router.push({ name: "統計排名" });
    },

    getExcel() {
      this.$refs.tab.getExcel();
    },
  },
};
</script>

<style>
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
</style>